import * as Yup from 'yup'

export const initialCreateCustomerFormValues = (values) => {
    return {
        user_id: values.user_id,
        email_verified: values.email_verified?.toString() || 0,
        retailer_type: values.retailer_type?.toString() || "",
        activate_bank_payment: values.activate_bank_payment?.toString() || "",
        activate_net30: values.activate_net30?.toString() || "",
        email: values.email || "",
        password: values.password || "",
        license_number: values.license_number || "",
        // business_license: values.business_license || "",
        first_name: values.first_name || "",
        middle_name: values.middle_name || "",
        last_name: values.last_name || "",
        company_name: values.company_name || "",
        customer_group_id: values.customer_group_id || ""
    }
}

export const validationSchema = Yup.object({
    first_name: Yup.string().required('This field is required'),
    last_name: Yup.string().required('This field is required'),
    company_name: Yup.string().required('This field is required'),
    email: Yup.string().email('Invalid email address').required('This field is required'),
    // password: Yup.string()
    //     .required('This field is required')
    // .matches(/^(?=.{8,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).*$/, "Password must have a small letter, a capital letter, a number, and a symble."),
})

export const isDetailsFilled = (values) => {
    return (values.first_name &&
        values.middle_name &&
        values.last_name &&
        values.company_name &&
        values.password &&
        values.retailer_type &&
        values.email &&
        values.customer_group_id && true)

}
export const isAddressFilled = (values) => {
    return (values.address_type &&
        values.address_shipping_first_name &&
        values.address_shipping_middle_name &&
        values.address_shipping_last_name &&
        values.address_shipping_company_name &&
        values.address_shipping_address &&
        values.address_shipping_address1 &&
        values.address_shipping_city &&
        values.address_shipping_country &&
        values.address_shipping_state &&
        values.address_shipping_zipcode &&
        values.address_shipping_phone &&
        values.address_shipping_mobile &&
        values.address_shipping_fax && true)
}


